import posthog from 'posthog-js'

export default {
    install(app) {
        // Only initialize PostHog in production environment
        if (import.meta.env.MODE === 'production') {
            app.config.globalProperties.$posthog = posthog.init('phc_EuZmZUOoMYV5Mkgbqg5BMQxWZHFSaWWsb1Rq2ADGV1P', {
                api_host: 'https://us.i.posthog.com',
            })
        } else {
            // Create a no-op object for dev environments to prevent errors
            app.config.globalProperties.$posthog = {
                identify: () => {},
                group: () => {},
                reset: () => {},
            }
        }
    },
}
